// AlarmSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AlarmsState {
  showAlarms: boolean;
  showWeather: boolean;
  filterTerm: string;
}

const initialState: AlarmsState = {
  showAlarms: false,
  showWeather: false,
  filterTerm: ''
};

const alarmSlice = createSlice({
  name: 'alarms',
  initialState,
  reducers: {
    toggleShowAlarms(state) {
      state.showAlarms = !state.showAlarms;
    },
    toggleShowWeather(state) {
      state.showWeather = !state.showWeather;
    },
    setFilterTerm(state, action: PayloadAction<string>) {
      state.filterTerm = action.payload;
    }
  }
});

export const { toggleShowAlarms, toggleShowWeather, setFilterTerm } = alarmSlice.actions;
export default alarmSlice.reducer;
